import { render, staticRenderFns } from "./ProductVariantLoader.vue?vue&type=template&id=835982e2"
import script from "./ProductVariantLoader.vue?vue&type=script&lang=js"
export * from "./ProductVariantLoader.vue?vue&type=script&lang=js"
import style0 from "./ProductVariantLoader.vue?vue&type=style&index=0&id=835982e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports